import React, {PropTypes} from 'react';

import SvgIcons from "../restaurant/SvgIcons";

class ListViewValue extends React.PureComponent {
  static propTypes = {
    value: PropTypes.object
  };

  render() {
    return (
      <div className="Select-value icon-value">
        <span className="Select-value-label">
          <SvgIcons icon={this.props.value.label}/>
        </span>
      </div>
    );
  }
}

export default ListViewValue;



/** WEBPACK FOOTER **
 ** ./src/components/nav/ListViewValue.js
 **/